import { Navigator } from '@yleisradio/areena-types';
import { ControlLink } from 'components/DSLink';
import React from 'react';
import styles from './FooterLink.module.scss';

type Props = {
  control: Navigator;
};

export const FooterLink: React.FC<Props> = ({ control }) => {
  return (
    <>
      <span className={styles.mobile}>
        <ControlLink control={control} textSize="m" />
      </span>
      <span className={styles.desktop}>
        <ControlLink control={control} textSize="l" />
      </span>
    </>
  );
};
